import { Exclude, Expose, Type } from 'class-transformer';
import { IsString, IsArray, ValidateNested, IsOptional } from 'class-validator';
import { JobSignoffInterface } from '../interfaces/job-signoff.interface';
import { BoardFloorInterface } from '../../board-floor/interfaces/board-floor.interface';
import { JobPhaseInterface } from '../../job-phase/interfaces/job-phase.interface';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';
import { BoardPurchaseFloorDto } from '../../board-purchase-floor/dto/board-purchase-floor.dto';
import { BoardPurchaseInterface } from '../../board-purchase/interfaces/board-purchase.interface';

@Exclude()
export class JobSignoffDto implements JobSignoffInterface {
  @Expose()
  @ApiProperty({
    title: 'Board Purchase Id',
  })
  @IsString()
  boardPurchaseId!: string;
  boardPurchase?: BoardPurchaseInterface | undefined;
  @ApiPropertyOptional({
    type: () => [BoardPurchaseFloorDto],
    title: 'Board Purchase Floor',
    description: 'Board Purchase Floor ',
  })
  @Expose()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => BoardPurchaseFloorDto)
  boardReceiptFloors!: BoardFloorInterface[];
}
